import { ButtonSwitch } from "design_system";
import Tag from "components/Tag";
import { ANNUAL_PRICE_DISCOUNT } from "constants/config";
import useLabels from "hooks/useLabels";

export enum PricingSwitchFlag {
  MONTHLY = "monthly",
  ANNUALLY = "annually",
}

type PricingSwitchProps = {
  onChange: (flag: PricingSwitchFlag) => void;
  value: PricingSwitchFlag;
};

function PricingSwitch({
  onChange,
  value = PricingSwitchFlag.ANNUALLY,
}: PricingSwitchProps) {
  const [pricingLabels] = useLabels("screens.pricing");

  if (!onChange) {
    throw new Error("onChange props is required!");
  }

  const handleOnChange = (selectedOption: string) => {
    const newFlag =
      selectedOption === pricingLabels["monthly"]
        ? PricingSwitchFlag.MONTHLY
        : PricingSwitchFlag.ANNUALLY;

    onChange(newFlag);
  };

  // Convert flag to label for ButtonSwitch
  const selectedOption =
    value === PricingSwitchFlag.MONTHLY
      ? pricingLabels["monthly"]
      : pricingLabels["annually"];

  return (
    <div className="relative inline-block">
      {value === PricingSwitchFlag.MONTHLY && (
        <Tag
          label={pricingLabels["save-discount"].replace(
            "{DISCOUNT}",
            ANNUAL_PRICE_DISCOUNT
          )}
          size="sm"
          variant="YES"
          className="absolute right-[-6px] top-[-9.5px] z-9"
        />
      )}
      <ButtonSwitch
        optionOne={pricingLabels["monthly"]}
        optionTwo={pricingLabels["annually"]}
        selectedOption={selectedOption}
        onChange={handleOnChange}
      />
    </div>
  );
}

export default PricingSwitch;
